module.exports = __webpack_public_path__ + "static/img/A75.5c6a4c5a.jpg";